import { IProposalUploadUrlRequest, IProposalUploadUrlResponse, IRequestProposalMessage } from "../contracts/Proposal";
import { getDataAsync, postDataAsync } from "../ZeosApiExecutor";
import { IProposals } from "./interfaces/IProposals";

const proposalsPrefix = "/proposals/";

export const Proposals: IProposals = {
  createUploadUrl: async (request: IProposalUploadUrlRequest) => {
    const response = await postDataAsync<IProposalUploadUrlResponse>(
      `${proposalsPrefix}upload-url`,
      request
    );
    return response;
  },
  requestProposal: async (request: IRequestProposalMessage) => {
    const response = await postDataAsync<boolean>(
      `${proposalsPrefix}request`,
      request
    );
    return response;
  },
};
